/**
 * Базовый класс для страницы продукта - ОПИФ, БПИФ
 */

import PieChart from '~/js/modules/pie-chart-product';
import StockChart from '~/js/modules/stock-chart-product';
import getSwiperSlider from '~/js/modules/slider';
import Accordion from '~/js/modules/accordion';
import Tooltip from '~/js/modules/tooltip';
import getScrollDirection from '~/js/helpers/get-scroll-direction';
import Highcharts from "highcharts";
import checkResource from '~/js/modules/product/checkResource';
import getJSON from '~/js/helpers/xhr';

export default class PageProduct {

  constructor() {
    this.elementsSlider = document.querySelectorAll(`.investments__slider, .news__slider`);
    // this.elementInvestButton = document.querySelectorAll('.invest-btn');
    this.elementTooltip = document.querySelectorAll('.js-tooltip-question');
    this.elementTooltipNoOffse  = document.querySelectorAll('.js-tooltip-buttons');
    this.elementAccordions = document.querySelectorAll('.accordion');

    //Навигация по секциям
    this.anchorLinks = document.querySelectorAll('.anchor .anchor-nav__link');
    this._anchorBlock = document.querySelector('.anchor');
    this._header = document.querySelector('.header');

    // this._pressButtonInvest = this._pressButtonInvest.bind(this);
    this._proccessSlider = this._proccessSlider.bind(this);
    this._proccessTooltip = this._proccessTooltip.bind(this);
    this._proccessAccordion = this._proccessAccordion.bind(this);

    this.init();
  }
  /**
   * Клик на кнопку инвестировать
   */
  // _pressButtonInvest(event) {
  //   event.preventDefault();
  //   let anchorElem = document.querySelector('#howtobuy-block');
  //   if(anchorElem) {
  //     window.scrollTo({
  //       top:  (anchorElem.getBoundingClientRect().top + window.pageYOffset - (this._header.offsetHeight + this._anchorBlock.offsetHeight)),
  //       behavior: 'smooth'
  //     });
  //   }
  // }
  /**
   * Инициализация слайдеров
   * @param element
   */
  _proccessSlider(element) {
    getSwiperSlider(element, {
      slidesPerView: `auto`,
      loop: false,
      autoplay: false,
      navigation: {
        nextEl: `.news .slider-arrows__arrow--next`,
        prevEl: `.news .slider-arrows__arrow--prev`,
        disabledClass: `disabled`,
      },
      pagination: false,
    });
  }
  /**
   * Инициализация всплывающих окон
   * @param element
   */
  _proccessTooltip(element, offset = [0, 8]) {
    new Tooltip(element, {
      modifiers: [
        {
          name: 'offset',
          options: {
            offset: offset,
          },
        },
      ],
    });
  }
  /**
   * Инициализация аккордеона
   * @param element
   */
  _proccessAccordion(element) {
    if(!element.classList.contains('main-nav__list')) {
      new Accordion(element);
    }
  }
  /**
   * Инициализация кнопки корзины
   */
  _proccessBasket() {
    let basket = document.querySelector('#mobile-fixed-button');
    if(basket) {
      let toggleBasketClass = () => {
        if (window.pageYOffset > 0) {
          basket.classList.add('active');
        } else {
          basket.classList.remove('active');
          basket.removeAttribute('disabled');
        }
      };
      toggleBasketClass();
      window.addEventListener('scroll', () => {
        toggleBasketClass();
      });
    }
  }
  /**
   * Инициализация навигации по секциям
   */
  _proccessSectionNavigation() {
    //Навигация по секциям
    const anchorLinks = document.querySelectorAll('.anchor .anchor-nav__link');

    if(anchorLinks.length) {

      const anchorBlock = document.querySelector('.anchor');
      const header = document.querySelector('.header');
      let anchorNames = [];

      anchorLinks.forEach((link) => {
        let anchorName = link.getAttribute('data-anchor');
        anchorNames.push(anchorName);
      });

      anchorLinks.forEach((link) => link.addEventListener('click', (evt) => {
          evt.preventDefault();
          let elem = evt.currentTarget;
          let anchorName = elem.getAttribute('data-anchor');
          setTimeout(function () {
            anchorLinks.forEach((link) => link.classList.remove('active'));
            elem.classList.add('active');
          }, 300);
          anchorNames.push(anchorName)
          let anchorElem = document.querySelector('#' + anchorName);
          if (anchorElem) {
            window.scrollTo({
              top: (anchorElem.getBoundingClientRect().top + pageYOffset - (header.offsetHeight + anchorBlock.offsetHeight)),
              behavior: 'smooth'
            });
          }
        })
      );

      let boxLoad = anchorBlock.getBoundingClientRect();
      let topLoad = boxLoad.top + pageYOffset;

      let i = 0;

      function schrollAnchor() {
        const down = getScrollDirection() === 1;
        const up = getScrollDirection() === -1;

        let box = anchorBlock.getBoundingClientRect();
        let topAnchorBlock = box.top + pageYOffset;
        let anchorElem = document.getElementById(anchorNames[i]);
        let anchorElemBox = anchorElem.getBoundingClientRect();
        let topAnchorElem = anchorElemBox.top + pageYOffset;
        let firstProductBlock = document.getElementById('fund-advantages-block');
        let anchorBox = document.querySelector(`.anchor .anchor__container`);
        let anchorBoxSize = anchorBox.getBoundingClientRect();

        let headerHeight = header.classList.contains('header--scrolled') ? (header.offsetHeight) : header.offsetHeight;

        if (down) {

          if ((topAnchorElem) < (topAnchorBlock + anchorBlock.offsetHeight * 2)) {
            anchorLinks.forEach((link) => link.classList.remove('active'));
            let activeAnchor = document.querySelector(`[data-anchor=${anchorNames[i]}]`);
            let activeAnchorSize = activeAnchor.getBoundingClientRect();
            let activePos = activeAnchorSize.left - anchorBoxSize.left + (activeAnchorSize.width / 2) - (anchorBoxSize.width / 2);
            activeAnchor.classList.add('active');
            anchorBox.scrollLeft = activePos;

            if (anchorLinks.length - 1 !== i) {
              i++;
            }
          }
          if ((pageYOffset + headerHeight) >= topAnchorBlock) {
            anchorBlock.style.top = headerHeight + 'px';
            header.classList.add('header--title');
            if (header.classList.contains('header--title') && (pageYOffset + (header.offsetHeight)) >= (topAnchorBlock)) {
              anchorBlock.classList.add('anchor--scrolled');
              anchorBlock.style.top = headerHeight + 'px';
              if(window.innerWidth >= 768) {
                firstProductBlock.style.marginTop = headerHeight + 77 + 'px';
              }
              else {
                firstProductBlock.style.marginTop = headerHeight + 'px';
              }
            }
          } else {
            anchorBlock.classList.remove('anchor--scrolled');
            anchorBlock.removeAttribute('style');
            firstProductBlock.removeAttribute('style');
          }
        }
        if (up) {

          /* Активация пунктов меню при прокрутке */
          if (topAnchorBlock < (topAnchorElem + anchorElem.offsetHeight)) {
            anchorLinks.forEach((link) => link.classList.remove('active'));
            let activeAnchor = document.querySelector(`[data-anchor=${anchorNames[i]}]`);
            let activeAnchorSize = activeAnchor.getBoundingClientRect();
            activeAnchor.classList.add('active');
            anchorBox.scrollLeft = activeAnchorSize.left - anchorBoxSize.left + (activeAnchorSize.width - anchorBoxSize.width) / 2;
            if (i !== 0) {
              i--;
            }
          }

          if ((pageYOffset + headerHeight) <= topLoad) {
            anchorBlock.classList.remove('anchor--scrolled');
            anchorBlock.removeAttribute('style');
            header.classList.remove('header--title');
            firstProductBlock.removeAttribute('style');
          } else {
            if (header.classList.contains('header--title')) {
              anchorBlock.classList.add('anchor--scrolled');
              anchorBlock.style.top = (header.offsetHeight) + 'px';
              if(window.innerWidth >= 768) {
                firstProductBlock.style.marginTop = headerHeight + 77 + 'px';
              }
              else {
                firstProductBlock.style.marginTop = headerHeight + 'px';
              }
            }
          }
        }
      }

      window.addEventListener('scroll', schrollAnchor);
    }
  }

  _proccessPieChar() {
    const pieChartBlocks = document.querySelectorAll(`.js-pie-block`);
    const pieChartOptions = {
      chart: {
        type: `pie`,
        height: '260',
        width: '260',
        margin: 0,
        spacing: [0, 0, 0, 0],
        style: {
          fontFamily: `'Montserrat', sans-serif`,
        },
        events: {
          load() {
            const data = this.series[0] ? this.series[0].data : null;

            if (data) {
              const selectedItem = this.series[0].data.filter((el) => el.visible && el.selected)[0];

              if (selectedItem) {
                if (window.location.href.includes("indexes")) {
                  const value = Highcharts.numberFormat(selectedItem.percentage, 2, '.');
                  this.title.textStr = value;
                  this.title.element.textContent = `${value} %`;
                }
                else {
                  const value = Highcharts.numberFormat(selectedItem.money, 1, ',');
                  this.title.textStr = value;
                  this.title.element.textContent = `${value} ₽`;
                }
              }
            }

            const points = this.series[0] ? this.series[0].points : null;

            if (points) {
              points.forEach((point) => {
                point.graphic.element.style.color = point.color;
              });
            }
          },
          redraw() {
            const data = this.series[0] ? this.series[0].data : null;

            if (data) {
              const selectedItem = this.series[0].data.filter((el) => el.visible && el.selected)[0];

              document.querySelectorAll('.highcharts-point').forEach((p, index) => {
                p.addEventListener('click', (evt) => {
                  if (document.querySelector('.js-pie-legend .active')) {
                    document.querySelector('.js-pie-legend .active').classList.remove('active');
                  }
                  const legendItems = document.querySelectorAll('.charts__legend-item');
                  legendItems[index].classList.add('active');
                  console.log(this.series[0].data[index])
                  if (window.location.href.includes("indexes")) {
                    const valueTitle = Highcharts.numberFormat(this.series[0].data[index].percentage, 2, '.');
                    this.title.textStr = valueTitle;
                    this.title.element.textContent = `${valueTitle} %`;
                  }
                  else {
                    const valueTitle = Highcharts.numberFormat(this.series[0].data[index].money, 1, ',');
                    this.title.textStr = valueTitle;
                    this.title.element.textContent = `${valueTitle} ₽`;
                  }
                })
              });

              if (selectedItem) {
                if (window.location.href.includes("indexes")) {
                  const value = Highcharts.numberFormat(selectedItem.percentage, 2, '.');
                  this.title.textStr = value;
                  this.title.element.textContent = `${value} %`;
                }
                else {
                  const value = Highcharts.numberFormat(selectedItem.money, 1, ',');
                  this.title.textStr = value;
                  this.title.element.textContent = `${value} ₽`;
                }
              } else {
                this.title.textStr = ``;
                this.title.element.textContent = ``;
              }
            }
          }
        }
      },
      colors: null,
      credits: {
        enabled: false
      },
      // https://jsfiddle.net/gh/get/jquery/1.7.2/highcharts/highcharts/tree/master/samples/highcharts/css/legend/
      // https://www.highcharts.com/docs/chart-design-and-style/style-by-css
      legend: {
        enabled: false,
        layout: 'vertical',
        align: 'right',
        verticalAlign: 'top',
        y: 30,
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          center: [`50%`, `50%`],
          cursor: `pointer`,
          dataLabels: {
            enabled: false
          },
          events: {
            click: null
          },
          showInLegend: true,
          // innerSize: `99%`,
          size: `90%`,
          borderWidth: 0,
          slicedOffset: 0,
          states: {
            select: {
              borderWidth: 5,
            },
            hover: {
              halo: {
                size: 0,
              }
            }
          }
        }
      },
      responsiveRules: {
        plotOptions: {
          pie: {
            innerSize: `95%`,
          },
        },
      },
      series: null,
      title: {
        align: `center`,
        margin: 0,
        style: {
          color: `#0C0E11`,
          fontWeight: `500`,
          fontFamily: `'Montserrat', sans-serif`,
          fontSize: `17px`,
        },
        text: ``,
        useHTML: true,
        verticalAlign: `middle`,
        widthAdjust: 0,
      },
      tooltip: {
        pointFormat: `<b>{point.percentage:.2f}%</b>`,
        outside: true
      },
    };
    pieChartBlocks.forEach((chart) => new PieChart({
      chart,
      options: pieChartOptions,
    }));
  }

  _proccessStockChar() {
    const stockChartBlocks = document.querySelectorAll(`.js-stock-chart-wrap`)
    const options = {
      chart: {
        // animation: false,
        height: 600,
        marginTop: 25,
        marginBottom: 25,
        // type: 'spline',
        marginLeft: 1,
        marginRight: 1,
        spacing: 0,
        plotBorderWidth: 1,
        plotBorderColor: `#919aa6`,
        style: {
          fontFamily: `'Montserrat', sans-serif`,
        },
      },
      credits: {
        enabled: false
      },
      legend: {
        enabled: false,
        align: `left`,
        itemDistance: 30,
        itemStyle: {
          color: `#000000`,
          fontWeight: `400`,
          fontSize: `1.2rem`,
        },
        margin: 0,
        padding: 0,
        symbolPadding: 10,
        useHTML: true,
        y: 40,
      },
      navigator: {
        height: 54,
        handles: {
          width: 20,
          height: 20,
          symbols: [
            `url(assets/dist/img/i-chart-handle.svg)`,
            `url(assets/dist/img/i-chart-handle.svg)`
          ],
        },
        outlineColor: `#d1d7db`,
        xAxis: {
          labels: {
            align: `center`,
            style: {
              color: `#75808f`,
              fontSize: `0.8rem`,
            },
            // x: 0,
            y: -20,
          },
        },
        units: [
          [`year`,
            [1, 2]
          ],
        ],
      },
      plotOptions: {
        series: {
          // animation: false
          showCheckbox: true
        },
        line: {
          showInNavigator: true,
        }
      },
      rangeSelector: {
        enabled: true,
        floating: true,
        y: -50,
        x: 0,
        selected: 4,
        buttons: [{
          type: 'month',
          count: 1,
          text: '1m'
        }, {
          type: 'month',
          count: 3,
          text: '3m'
        }, {
          type: 'month',
          count: 6,
          text: '6m'
        }, {
          type: 'ytd',
          text: 'YTD'
        }, {
          type: 'year',
          count: 1,
          text: '1y'
        }, {
          type: 'year',
          count: 3,
          text: '3y'
        }, {
          type: 'year',
          count: 5,
          text: '5y'
        }, {
          type: 'all',
          text: 'All'
        }],
        buttonPosition: {
          align: `right`,
          // x: 0,
        },
        inputEnabled: false,
        inputPosition: {
          align: `left`,
          x: 0,
        },
        // inputBoxWidth: 100,
        // inputBoxHeight: 40,
        inputDateFormat: `%d.%m.%Y`,
        inputEditDateFormat: `%d.%m.%Y`,
      },
      responsiveRules: {
        navigator: {
          xAxis: {
            labels: {
              style: {
                fontSize: `0.875rem`,
              },
            },
          },
        },
        legend: {
          itemDistance: 60,
          itemStyle: {
            fontSize: `1.125rem`,
          },
          symbolPadding: 20,
        },
        xAxis: {
          labels: {
            style: {
              fontSize: `0.875rem`,
            },
          },
        },
        yAxis: {
          labels: {
            style: {
              fontSize: `0.875rem`,
            },
            x: 20,
            y: -8,
          },
        },
      },
      scrollbar: {
        enabled: false,
      },
      tooltip: {
        headerFormat: "",
        xDateFormat: '%d.%m.%Y',
        pointFormatter() {
          const value = this.y.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
          const beginItem = this.series.cropStart ? this.series.yData[this.series.cropStart+1] : this.series.yData[this.series.cropStart];
          const diff = (this.y / beginItem * 100 - 100).toFixed(2);
          let date = new Date(this.x).toLocaleDateString('ru-RU', {weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
          let dateTime = new Date(this.x).toLocaleDateString('ru-RU', {weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric'});
          date = date[0].toUpperCase() + date.slice(1);
          let $return = `<b >${dateTime}</b><br/><span style="color:${this.series.color}">${this.series.name}</span>: <b>${diff}%</b> (${value})`;
          return `
            <b>${dateTime}</b><br/>
            <span style="color:${this.series.color}">${this.series.name}: <b>${value}</b></span><br/>
            <span style="color:${this.series.color}">Прирост: </span><b>${diff}%</b>`;

        },
        valueDecimals: 2,
        split: true,
      },
      xAxis: {
        events: {
          // afterSetExtremes(evt) {
          //   stockChartCallbacks.afterSetExtremes(evt);
          // }
        },
        id: `navigatorXAxis`,
        gridLineWidth: 1,
        gridLineColor: `#d1d7db`,
        labels: {
          style: {
            color: `#75808f`,
            fontSize: `0.8rem`,
          },
        },
        units: [ [
          'day',
          [1, 2]
        ], [
          'week',
          [1, 2]
        ], [
          'month',
          [1, 2, 3, 4, 6]
        ], [
          'year',
          [1, 2]
        ]
        ]
      },
      yAxis: [{ // left y axis
        opposite: false,
        title: {
          text: null
        },
        labels: {
          align: 'left',
          style: {
            color: `#75808f`,
            fontSize: `0.8rem`,
          },
          x: 10,
          y: -10,
        },
        // showFirstLabel: false
      }, { // right y axis
        linkedTo: 0,
        gridLineWidth: 0,
        opposite: true,
        title: {
          text: null
        },
        labels: {
          align: 'right',
          style: {
            color: `#75808f`,
            fontSize: `0.8rem`,
          },
          x: -10,
          y: -10,
        },
        // showFirstLabel: false
      }],
      series: [],
      seriesCounter: 0,
    }

    let chartsParams = []
    let resIdBase = null
    if (stockChartBlocks) {
      resIdBase = stockChartBlocks[0].querySelector(`.js-stock-chart`).getAttribute(`data-res-id`)
    }

    getJSON(`/assets/components/dohod/connectorweb.php?action=chartsParams/get&resId=${resIdBase}`).then((data) => {
      data.tabs = data.tabs.filter(tab => tab !== null)
      chartsParams.push(data);

      stockChartBlocks.forEach((chart) => {
          let stockChart = chart.querySelector(`.js-stock-chart`)
          let tab = stockChart.getAttribute(`data-tab`) ? stockChart.getAttribute(`data-tab`) : 'prices';
          let type = stockChart.getAttribute(`data-type`) ? stockChart.getAttribute(`data-type`) : null;
          let action = stockChart.getAttribute(`data-action`) ? stockChart.getAttribute(`data-action`) : null;
          let resId = stockChart.getAttribute(`data-res-id`) ? stockChart.getAttribute(`data-res-id`) : null;

          let chartUrl = ``
          if (type) {
            chartUrl = `assets/components/dohod/connectorweb.php?type=${type}&tab=${tab}&action=${action}&resId=${resId}`
          } else {
            chartUrl = `assets/components/dohod/connectorweb.php?tab=${tab}&action=${action}&resId=${resId}`
          }
          checkResource(chartUrl, stockChartBlocks)

          new StockChart({
            chart,
            options: options,
            chartsParams: chartsParams
          });
        }
      )

    })
  }

  init() {
    window.addEventListener('DOMContentLoaded', () => {

      // this.elementInvestButton.forEach((element) => element.addEventListener(`click`, this._pressButtonInvest));
      this.elementsSlider.forEach((element) => this._proccessSlider(element));
      this.elementTooltip.forEach((element) => this._proccessTooltip(element));
      this.elementTooltipNoOffse.forEach((element) => this._proccessTooltip(element, [0, 0]));

      this._proccessBasket();
      //Аккордеоны
      this.elementAccordions.forEach((element) => this._proccessAccordion(element))
      // Навигация по секциям
      this._proccessSectionNavigation();
      // Диаграмма
      this._proccessPieChar();
      // Графики
      this._proccessStockChar();

    });
  }
}